import { Image, Container, Row, Col } from 'react-bootstrap';
import Img from '../Img/Bag/Bags-Banner.jpg';
import CircularGallery from './CircularBagGallery';
import "./Services.css";

function Bags() {
    return (
        <>
            <Image className="fade-in responsive-img" src={Img} height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className='text-center my-4 text-decoration-underline'><strong>BAGS</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>Eco-friendly, recycled, up-cycled, organic… our vendors cover the entire range of options for handcrafted bags. Available in a wide selection of materials such as jute, hemp, linen, cotton, PET yarn & leather.</p>
                    </Col>
                </Row>
            </Container>
            <div style={{ height: '600px', position: 'relative' }}>
                <CircularGallery bend={3} borderRadius={0.05} scrollEase={0.02} />
            </div>
        </>
    )
}

export default Bags